import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { StorageService } from './storage.service';

export const storeInSession =
  (service: StorageService, key: string) =>
  <T>(obs: Observable<T>): Observable<T> =>
    obs.pipe(
      tap(data => {
        if (data !== undefined && data !== null) {
          service.putInSessionStorage(key, data);
        } else {
          service.removeFromSessionStorage(key);
        }
      })
    );
